import React from 'react'

export default function UpgradeTiny() {
    return (
   
            <small>	&nbsp; <span className="badge badge-danger"> upgrade</span>	&nbsp;</small>
  
    )
}
